import React from 'react';
import { withRouter } from 'react-router-dom';

class CustomLink extends React.Component {
  navigate = (e) => {
    e.preventDefault();
    const { to, location, history } = this.props;

    // Building the current full path (pathname + search)
    const currentFullPath = location.pathname + location.search;
    // Assuming 'to' includes the full path you intend to navigate to (pathname + search)
    const targetFullPath = to;

    // Comparing the current full path with the target full path
    if (currentFullPath === targetFullPath) {
      //window.location.href = to; // This will force the page to reload
    } else {
      history.push(to); // This navigates without reloading the page
    }
  };

  render() {
    const { to, children } = this.props;
    return <a href={to} onClick={this.navigate}>{children}</a>;
  }
}

export default withRouter(CustomLink);
